import Lara from "@primeng/themes/lara";
import { definePreset } from "@primeng/themes";

const PrimengLaraLightPreset = definePreset(Lara, {
    primitive: {
        blue: {
            50: "#eff6ff",
            100: "#dbeafe",
            200: "#bfdbfe",
            300: "#93c5fd",
            400: "#60a5fa",
            500: "#3b82f6",
            600: "#2563eb",
            700: "#1d4ed8",
            800: "#1e40af",
            900: "#1e3a8a",
            950: "#172554"
        }
    },
    semantic: {
        primary: {
            50: "{blue.50}",
            100: "{blue.100}",
            200: "{blue.200}",
            300: "{blue.300}",
            400: "{blue.400}",
            500: "{blue.500}",
            600: "{blue.600}",
            700: "{blue.700}",
            800: "{blue.800}",
            900: "{blue.900}",
            950: "{blue.950}"
        },
        overlay: {
            popover: {
                padding: "2px"
            }
        },
        colorScheme: {
            light: {
                formField: {
                    hoverBorderColor: "#040404",
                    borderColor: "#a1a2a3",
                    disabledBackground: "#c2c2c2d9",
                    disabledColor: "#75787c"
                },
                content: {
                    color: "#4b5563",
                    hoverColor: "#3b82f6",
                    borderColor: "#c8cacd"
                },
                overlay: {
                    popover: {
                        padding: "0.5rem",
                        borderColor: "black"
                    }
                },
            }
        }
    },
    components: {
        multiselect: {
            root: {
                paddingX: "4px",
                paddingY: "4px",
                //borderColor: "#a1a2a3",
                borderRadius: "6px"
            }
        },
        inputtext: {
            root: {
                paddingX: "3px",
                paddingY: "3px",
                sm: {
                    fontSize: "0.95rem",
                    paddingX: "5px",
                    paddingY: "3px"
                },
                lg: {
                    fontSize: "0.95rem"
                }
            },
        },
        togglebutton: {
            root: {
                background: "white",
                borderColor: "white",
                color: "black",
                checkedBackground: "#3b82f6",
                checkedColor: "white",
                padding: "5px"
            }
        },
        datepicker: {
            header: {
                padding: "5px"
            },
            dayView: {
                margin: "0"
            },
            date: {
                width: "1.5rem",
                height: "1.5rem",
                padding: "5px",
                color: "#4b5563"
            },
            title: {
                gap: "0",
                fontWeight: "500"
            },
            timePicker: {
                padding: "0",
                gap: "0",
                buttonGap: "0"
            },
            buttonbar: {
                padding: "0"
            },

            WeekDay: {
                fontWeight: "500"
            },
        },
        button: {
            label: {
                fontWeight: "500"
            }
        },
        fileupload: {
            root: {
                background: "white",
                borderColor: "white",
                color: "black",
                borderRadius: "white"
            },
            header: {
                borderWidth: "1px",
                borderColor: "#dee2e6",
                padding: "5px",
                borderRadius: "5px 5px 0 0",
                gap: "0.5rem"
            },
            content: {
                padding: "0px"
            },
            file: {
                padding: "5px",
                gap: "1rem",
                borderColor: "white",
                info: {
                    gap: "0.5rem"
                }
            }
        }
    }
});

export default PrimengLaraLightPreset;